import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TPVServices } from "../../../tpv/services";
import { Globals } from "../../../../globals";
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the ConfigurationRoomsCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-rooms-create',
    templateUrl: 'configuration-rooms-create.html',
})
export class ConfigurationRoomsCreatePage {

    public form: FormGroup;
    public room: any;
    update_state: boolean = false;
    editable_table: any;
    map_style: string = 'square';
    map: boolean = false;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public fb: FormBuilder,
        public tpvServices: TPVServices,
        public globals: Globals,
        public loadingCtrl: LoadingController,
        public translate: TranslateService) {

        this.globals.GAtrackView('Configuration', 'Configuration - Rooms - View', this.globals.restaurant.email, 'View', 'View room', 'Configuration', '');

        /*SE NECESITA PORQUE EN EL PARTIAL NO SE PUEDE HACER*/
        //Params
        this.update_state = this.navParams.get('update');
        if (this.update_state) {
            this.room = this.navParams.get('room');
            this.form = fb.group({
                name: [this.room.name, Validators.compose([Validators.required])],
                map: [this.room.map],
                order: [(this.room.order === undefined ? 0 : this.room.order)]
            });
        } else {
            this.form = fb.group({
                name: ['', Validators.compose([Validators.required])],
                map: [false],
                order: [0]
            });
        }
    }

    saveTables() {
        try {
            this.room.content.forEach(table => {
                const tableUpdate = { ...table };
                tableUpdate.map_top = parseInt(table.map_top);
                tableUpdate.map_left = parseInt(table.map_left);
                delete tableUpdate.UID;
                this.tpvServices.firestore.collection('tables').doc(table.UID).update(tableUpdate);
            });
            this.globals.launchToast(this.translate.instant('general-guardado-correctamente'), 3000, 'bottom');
            this.navCtrl.pop();
        } catch (error) {
            this.globals.launchToast(this.translate.instant('general-error-al-guardar'), 3000, 'bottom');
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-rooms/configuration-rooms-create/configuration-rooms-create.ts